/**
 * Status pill. `tone` maps to a colour; `map` lets a caller reuse the component
 * for customer status, lead temperature, appointment status, etc.
 */
const TONES = {
  NEW: 'slate',
  CONTACTED: 'blue',
  QUALIFIED: 'indigo',
  MEETING_BOOKED: 'violet',
  PROPOSAL_SENT: 'amber',
  NEGOTIATION: 'amber',
  WON: 'green',
  LOST: 'red',
  ON_HOLD: 'slate',
  DRAFT: 'slate',
  SUBMITTED: 'blue',
  CONVERTED: 'green',
  REJECTED: 'red',
  HOT: 'red',
  WARM: 'amber',
  COLD: 'blue',
  SCHEDULED: 'blue',
  CONFIRMED: 'green',
  DONE: 'slate',
  CANCELLED: 'red',
  NO_SHOW: 'red',
  ACTIVE: 'green',
  DISABLED: 'slate',
  TELEPRO: 'violet',
  COMMERCIAL: 'green',
  IT: 'blue',
  ADMIN: 'amber',
  DAY_OFF: 'amber',
  VACATION: 'violet',
  PARTIAL: 'blue',
  LOW: 'green',
  MEDIUM: 'amber',
  HIGH: 'red',
  // Delivery projects, in board order.
  TO_DO: 'slate',
  DEVELOPING: 'blue',
  QA: 'violet',
  READY: 'indigo',
  DELIVERED: 'green',
  SIGNED: 'green',
  NOT_SIGNED: 'slate',
};

const Badge = ({ value, label, tone }) => (
  <span className={`badge badge--${tone ?? TONES[value] ?? 'slate'}`}>{label ?? value}</span>
);

export default Badge;
